<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import api from './api';

export default {
  name: 'App',
  mounted() {
    // 手机端跳转到H5地址（通过UA判断）
    const ua = navigator.userAgent.toLowerCase()
    const isMobile = /mobile|android|iphone|ipad|ipod|blackberry|opera mini|iemobile/i.test(ua)

    if (isMobile) {
      api.get('/other/public/settings', { params: { keys: 'portal_h5_url' } }).then(res => {
        if (res.code === 0 && res.data && res.data.portal_h5_url) {
          window.location.href = res.data.portal_h5_url
        }
      }).catch(err => {
        console.error('获取配置失败:', err)
      })
    }
  }
};
</script>

<style>
:root {
  --primary: #2563EB;
  --primary-dark: #1E40AF;
  --primary-light: #3B82F6;
  --accent: #F59E0B;
  --accent-light: #FCD34D;
  --hero-start: #0F172A;
  --hero-end: #1E3A5F;
  --bg: #F8FAFC;
  --bg-white: #FFFFFF;
  --text-primary: #0F172A;
  --text-secondary: #64748B;
  --text-muted: #94A3B8;
  --border: #E2E8F0;
  --border-light: #F1F5F9;
  --shadow-sm: 0 1px 2px rgba(0,0,0,.05);
  --shadow: 0 1px 3px rgba(0,0,0,.08), 0 1px 2px rgba(0,0,0,.04);
  --shadow-md: 0 4px 6px -1px rgba(0,0,0,.07), 0 2px 4px -2px rgba(0,0,0,.05);
  --shadow-lg: 0 10px 15px -3px rgba(0,0,0,.08), 0 4px 6px -4px rgba(0,0,0,.04);
  --radius-sm: 6px;
  --radius: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: 'DM Sans', 'Noto Sans SC', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  color: var(--text-primary);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
}
#app {
  min-height: 100vh;
}

/* Element UI 主题覆盖 */
.el-button--primary {
  background: linear-gradient(135deg, var(--primary), var(--primary-dark)) !important;
  border: none !important;
  border-radius: var(--radius) !important;
  font-weight: 600 !important;
  letter-spacing: .3px;
  box-shadow: 0 2px 8px rgba(37,99,235,.25);
  transition: all .25s ease !important;
}
.el-button--primary:hover,
.el-button--primary:focus {
  background: linear-gradient(135deg, var(--primary-light), var(--primary)) !important;
  box-shadow: 0 4px 14px rgba(37,99,235,.35);
  transform: translateY(-1px);
}
.el-button--primary.is-plain {
  background: transparent !important;
  color: var(--primary) !important;
  border: 1.5px solid var(--primary) !important;
  box-shadow: none !important;
}
.el-button--primary.is-plain:hover {
  background: var(--primary) !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(37,99,235,.25) !important;
}
.el-button--default {
  border-radius: var(--radius) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
  font-weight: 500 !important;
  transition: all .25s ease !important;
}
.el-button--default:hover {
  border-color: var(--primary) !important;
  color: var(--primary) !important;
  box-shadow: var(--shadow-sm);
}
.el-button.is-round {
  border-radius: 50px !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--primary) !important;
  border-radius: var(--radius-sm) !important;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  box-shadow: none !important;
  border-radius: var(--radius-sm) !important;
}
.el-radio-button__inner {
  border-radius: var(--radius-sm) !important;
  border-color: var(--border) !important;
  color: var(--text-secondary) !important;
  font-weight: 500;
  transition: all .2s !important;
}
.el-radio-button__inner:hover {
  color: var(--primary) !important;
}
.el-tag {
  border-radius: 50px !important;
  font-weight: 500;
  border: none !important;
}
.el-card {
  border-radius: var(--radius-lg) !important;
  border: 1px solid var(--border-light) !important;
  box-shadow: var(--shadow-sm) !important;
  transition: all .3s ease !important;
}
.el-card:hover {
  box-shadow: var(--shadow-md) !important;
}
.el-dialog {
  border-radius: var(--radius-xl) !important;
  overflow: hidden;
}
.el-dialog__header {
  border-bottom: 1px solid var(--border-light);
}
.el-divider {
  background-color: var(--border-light) !important;
}
</style>
